import { IApplicationState } from '../../types/redux';

/**
 * Выбирает регионы CPD для формы Сделки
 */
export const selectCpdRegions = ({ cpdRegions }: IApplicationState) => cpdRegions;
